/**
 * Convert an object to query string.
 * @param {*} obj 
 */
function serialize(obj) {
    let str = '?' + Object.keys(obj).reduce((a, k) => {
        a.push(k + '=' + encodeURIComponent(obj[k]));
        return a;
    }, []).join('&');
    return str;
}

/**
 * Fetch data function with query string parameters.
 * @param {*} path 
 * @param {*} params 
 */
export function fetchData(path = '', params = {}) {
    return fetch(path + serialize(params));
}

/**
 * Prototype function to make the string to title case.
 */
String.prototype.toTitleCase = function() {
    return this[0].toUpperCase() + this.substr(1).toLowerCase();
}

/**
 * Lock scroll of the document background.
 */
export function lockScroll() {
    if (document) {
        document.body.style.overflow = 'hidden';
        document.querySelector('.fadeIn').classList.add('blur');
        document.querySelector('#container').classList.add('blur');
        // document.querySelector('#background').classList.add('blur');
    }
}

/**
 * Unlock scroll of the document background.
 */
export function unlockScroll() {
    if (document) {
        document.body.style.overflow = 'initial';
        document.querySelector('.fadeIn').classList.remove('blur');
        document.querySelector('#container').classList.remove('blur');
        // document.querySelector('#background').classList.remove('blur');
    }
}